import { api } from '@/lib/api/axios';
import type {
  AppNotificationDto,
  NotificationSummaryDto,
  NotificationsResponseDto,
  WebPushPublicKeyDto,
  WebPushDeliveryResultDto,
  WebPushSubscriptionRequestDto,
} from '@/types/dto/notification.dto';

export const NotificationService = {
  list: async (limit = 20): Promise<NotificationsResponseDto> => {
    const { data } = await api.get<NotificationsResponseDto>('/notifications', {
      params: { limit },
    });

    return data;
  },
  summary: async (): Promise<NotificationSummaryDto> => {
    const { data } = await api.get<NotificationSummaryDto>('/notifications/summary');

    return data;
  },
  markRead: async (notificationId: string): Promise<AppNotificationDto> => {
    const { data } = await api.patch<AppNotificationDto>(`/notifications/${notificationId}/read`);

    return data;
  },
  markAllRead: async (): Promise<NotificationSummaryDto> => {
    const { data } = await api.patch<NotificationSummaryDto>('/notifications/read-all');

    return data;
  },
  getWebPushPublicKey: async (): Promise<WebPushPublicKeyDto> => {
    const { data } = await api.get<WebPushPublicKeyDto>('/notifications/push/public-key');

    return data;
  },
  subscribePush: async (subscription: WebPushSubscriptionRequestDto): Promise<void> => {
    await api.post('/notifications/push/subscriptions', subscription);
  },
  unsubscribePush: async (endpoint: string): Promise<void> => {
    await api.delete('/notifications/push/subscriptions', {
      data: { endpoint },
    });
  },
  sendTestPush: async (): Promise<WebPushDeliveryResultDto> => {
    const { data } = await api.post<WebPushDeliveryResultDto>('/notifications/push/test');

    return data;
  },
};
